require('./cancelCardPayLater.scss');
// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
// @ commons
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { OKButton } = require('components/commons/OKButton/OKButton');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
// @ helpers
const DateHelper = require('utilities/dateHelper');
const { formatAmountObject } = require('utilities/currencyHelper');
const { FormattedText, getLanguage } = require('core/i18n').i18n;
// @ constants
const { DATE_FORMAT_SLASHES_SHORT_DAY_MONTH_YEAR } = require('constants/index');

class CancelCardPayLater extends React.Component {
    constructor(props) {
        super(props);
    }

    buildInformativeList() {
        const { immCard, immCancelCardPayLater } = this.props;

        const dateOfOperation = DateHelper.buildFormattedDate(immCancelCardPayLater.get('dueDate'), DATE_FORMAT_SLASHES_SHORT_DAY_MONTH_YEAR);

        const plainAmountObject = {
            amount: immCancelCardPayLater.get('cancelledAmount'),
            currency: immCancelCardPayLater.get('currency')
        };

        const informativeItems = [
            <OKInformativeListItem
                key="cancelPayLater-amountText"
                title="cancelPayLater-amountText"
            >
                <OneLineSymbolAmount
                    amountObject={plainAmountObject}
                    className="cancel-pay-later__amount"
                    language={getLanguage()}
                    amountObjectFormatted={formatAmountObject(plainAmountObject, true)}
                />
            </OKInformativeListItem>,
            <OKInformativeListItem
                key="cancelPayLater-dueDateText"
                title="cancelPayLater-dueDateText"
                bodyText={dateOfOperation}
            />,
            <OKInformativeListItem
                key="cancelPayLater-currentAccountText"
                title="cancelPayLater-currentAccountText"
                bodyText={immCard.get('associatedAccount')}
            />
        ];

        return (
            <OKInformativeList columns={3}>
                {informativeItems}
            </OKInformativeList>
        );

    }

    render() {
        const { immCancelCardPayLater, routeToWizard } = this.props;
        const InformativeList = this.buildInformativeList();

        if (immCancelCardPayLater.get('isFetching')) {
            return <LoadingSection />;
        }

        return (
            <article className="cancel-pay-later">
                <OKSectionBox className="col-xs-12" >
                    <h1 className="cancel-pay-later__title">
                        <FormattedText value="cancelPayLater-pageTitle" />
                    </h1>
                    <div className="card-modify-limit-informative-section__body">
                        {InformativeList}
                    </div>
                    <footer className="cancel-pay-later__footer">
                        <OKButton className="pull-right" onClick={routeToWizard}>
                            <FormattedText value="cancelPayLater-buttonText" />
                        </OKButton>
                    </footer>
                </OKSectionBox>
            </article>
        )
    }
}

CancelCardPayLater.propTypes = {
    immCard: PropTypes.object.isRequired,
    immCancelCardPayLater: PropTypes.object.isRequired,
    routeToWizard: PropTypes.func
};

module.exports = CancelCardPayLater;
